<template>
  <div class="drop-select-container-parent">
    <VueCtkDateTimePicker
      v-if="type == 'timePicker'"
      :only-time="true"
      :no-label="true"
      :color="secCol"
      format="hh:mm a"
      v-model="time"
    >
      <button class="time-button" :style="{ 'z-index': zIndex }"></button>
    </VueCtkDateTimePicker>
    <div
      class="drop-select-container"
      :class="{ 'w-100': type == 'datePicker' }"
    >
      <div
        class="select animated zoomIn m-0"
        :style="{
          'z-index': zIndex,
          'pointer-events': type != 'select' ? 'none' : 'all',
        }"
      >
        <!-- You can toggle select (disabled) -->
        <input type="radio" :name="id" :disabled="disabled" />
        <i class="toggle fas fa-angle-up text-primary"></i>
        <i class="toggle fas fa-angle-down text-primary"></i>
        <span class="placeholder text-primary">
          <div class="sup-title">
            {{ supTitle }}
          </div>
          <unicon :name="icon" :fill="secCol" class="position-absolute icon">
          </unicon>
          <div class="text-option" style="text-overflow: ellipsis;">
            {{ placeholderText }}
          </div>
        </span>

        <div class="options custom-scroll">
          <label class="option" v-for="(item, i) in options" :key="i">
            <input
              type="radio"
              :name="id"
              :value="item[valueKey]"
              v-model="selectedItem"
              @change="setSelected"
            />
            <!-- @click="blurDropSelect($event)" -->
            <span class="title animated fadeIn text-primary">
              <div class="sup-title">{{ supTitle }}</div>
              <unicon
                :name="icon"
                :fill="secCol"
                class="position-absolute icon"
              >
              </unicon>
              <div class="text-option">
                {{ item[textKey] }}
              </div>
            </span>
          </label>
        </div>
        <span class="bottom-border"> </span>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapMutations } from "vuex";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "DropSelect",
  components: {
    VueCtkDateTimePicker,
  },
  props: {
    options: {
      type: Array,
    },
    placeholder: {
      type: String,
    },
    supTitle: {
      type: String,
    },
    id: {
      type: String,
    },
    zIndex: {
      type: Number,
      default: 1,
    },
    textKey: {
      type: String,
      default: "text",
    },
    valueKey: {
      type: String,
      default: "value",
    },
    selected: {},
    type: {
      default: "select",
    },
    date: {},
    icon: {},
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
      selectedItem: this.selected,
      time: "",
    };
  },
  methods: {
    blurDropSelect(e) {
      // console.log("BLUR EVENT", e);
      e.target.checked = false;
    },
    setSelected() {
      // console.log("SELECT OPTION");
      this.$emit("selected", { value: this.selectedItem, id: this.id });
      this.$emit("input", this.selectedItem);
    },
    setSelectedTime() {
      this.$emit("selectedTime", { value: this.time, id: this.id });
      this.$emit("input", this.time);
    },
  },
  computed: {
    placeholderText() {
      if (this.type == "datePicker") {
        return this.date || this.placeholder;
      } else if (this.type == "timePicker") {
        return this.time || this.placeholder;
      } else {
        return this.placeholder;
      }
    },
  },
  watch: {
    time() {
      if (this.type == "timePicker") this.setSelectedTime();
    },
    selected() {
      this.selectedItem = this.selected;
    },
  },
  async mounted() {
    if (!this.type) this.selectedItem = this.selected || this.value;
    if (this.type == "timePicker") {
      if (this.value) {
        this.time = this.value;
      } else {
        let time;
        let date = new Date();
        await this.$nextTick(() => {
          time = this.$formatAMPM(date);
        });
        this.time = time;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
$radius: 30px;

h1 {
  i {
    position: relative;
    font-size: 70px;
  }
  text-align: center;
  color: #fff;
  font-weight: 600;
  font-size: 3em;
  letter-spacing: 0px;
  text-shadow: 1px 1px rgba(0, 0, 0, 0.02), 2px 2px rgba(0, 0, 0, 0.02),
    3px 3px rgba(0, 0, 0, 0.02), 4px 4px rgba(0, 0, 0, 0.02),
    5px 5px rgba(0, 0, 0, 0.02), 6px 6px rgba(0, 0, 0, 0.02),
    7px 7px rgba(0, 0, 0, 0.02);
}

p {
  text-align: center;
  color: #fff;
  font-size: 14px;
  margin-bottom: 2em;
  line-height: 30px;
  img {
    position: relative;
    top: 8px;
    right: 10px;
  }
} // End | for demo
// Pure css Select
.select {
  position: relative;
  overflow: hidden;
  display: block;
  margin: auto;
  //width: 300px;
  height: 100%;
  border-bottom: 0px;
  border-radius: 3px;
  font-size: 12px;
  //box-shadow: 0px 1em 2em -1.5em rgba(0, 0, 0, 0.5);
  > i.toggle {
    position: absolute;
    z-index: 4;
    right: 1.5em;
    top: 1.6em;
    color: #ccc;
  }
  .title,
  .placeholder {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    padding: 1.5em 2em;
    background: rgba(255, 255, 255, 1);
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    cursor: pointer;
    background-color: #f0f0f0;
    color: #999;
  }
  & > input {
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 1;
    width: 90%;
    height: 100%;
    display: block;
    opacity: 0;
    cursor: pointer;
    &:checked {
      ~ i.toggle.fa-angle-down {
        display: none;
      }
      ~ i.toggle.fa-angle-up {
        display: block;
      }
      div.options label.option .title {
        display: none !important;
      }
      ~ span {
        border-top-left-radius: $radius;
        border-top-right-radius: $radius;
      }
      ~ .bottom-border {
        display: block;
      }
    }

    &:not(:checked) {
      z-index: 4;
      ~ .options > .option {
        > span.title {
          display: none;
        }
      }
      ~ i.toggle.fa-angle-up {
        display: none;
      }
      ~ i.toggle.fa-angle-down {
        display: block;
      }
      ~ span {
        border-radius: $radius;
      }
    }
    &:disabled {
      cursor: no-drop;
    }
  }
  & > span.placeholder {
    position: relative;
    z-index: 0;
    display: inline-block;
    width: 100%;
    color: #999;
    border-top: 0px;
  }
  .option {
    display: block;
    overflow: hidden;
    z-index: 1;
    width: 100%;
    transition: all 1s ease-out;
    span.title {
      position: relative;
      z-index: 5;
      transition: background 0.3s ease-out;
      i.icon {
        padding-right: 8px;
        color: rgba(146, 168, 209, 1);
      }
      &:hover {
        color: #fff;
        background: rgba(255, 255, 255, 1);
        box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.1);
        color: #999 !important;
      }
    }
    input {
      display: none;
      &:checked ~ span.title {
        position: absolute;
        display: block !important;
        z-index: 3;
        top: 0px;
        font-size: 12px;
        background: #fff;
        border-top: 0px;
        box-shadow: none;
        color: inherit;
        width: 100%;
        border-radius: $radius;
        background-color: #f0f0f0;
        color: #999;
        img,
        .icon {
          display: inline-block;
        }
        .sup-title {
          display: block;
        }
      }
      &:disabled {
        & ~ span.title {
          background: #f9f9f9 !important;
          color: #aaa;
          &:hover {
            color: #aaa;
            background: none;
            cursor: no-drop;
          }
        }
      }
    }
  }
  // .options > .option:last-child span {
  //   border-bottom-right-radius: $radius;
  //   border-bottom-left-radius: $radius;
  // }
} // Pure css select 2 TOGGLE
.select2 {
  position: relative;
  overflow: hidden;
  display: block;
  margin: auto;
  width: 330px;
  height: 100%;
  border-bottom: 0px;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0px 1em 2em -1.5em rgba(0, 0, 0, 0.5);
  i.toggle {
    position: absolute;
    z-index: 4;
    right: 1.5em;
    top: 1.6em;
    color: #ccc;
  }
  .title,
  .placeholder {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    padding: 1.5em 2em;
    background: rgba(255, 255, 255, 1);
    border-top: 1px solid rgba(8, 7, 7, 0.05);
    cursor: pointer;
  }
  & > label > input {
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 2;
    width: 100%;
    height: 100%;
    display: block;
    opacity: 0;
    cursor: pointer;
    &:checked {
      z-index: 2;
      ~ i.toggle.icon-plus {
        display: none;
      }
      ~ i.toggle.icon-minus {
        display: block;
      }
    }
    &:not(:checked) {
      ~ i.toggle.icon-minus {
        display: none;
      }
      ~ i.toggle.icon-plus {
        display: block;
      }
      ~ label.option input:not(:checked) ~ .title {
        display: none !important;
      }
    }
    &:disabled {
      cursor: no-drop;
    }
  }
  & label > span.placeholder {
    position: relative;
    z-index: 0;
    display: inline-block;
    width: 100%;
    color: #999;
    border-top: 0px;
  }
  label.option {
    display: block;
    overflow: hidden;
    z-index: 1;
    width: 100%;
    transition: all 1s ease-out;
    span.title {
      position: relative;
      z-index: 2;
      transition: background 0.3s ease-out;
      background-color: #f0f0f0;
      color: #999;
      i.icon {
        padding-right: 8px;
        color: rgba(146, 168, 209, 1);
      }
      &:hover {
        color: #fff;
        background: rgba(146, 168, 209, 0.5);
        box-shadow: inset 0px 1px 0px rgba(0, 0, 0, 0.1);
        background: white !important;
      }
    }
    input {
      display: none;
      &:checked ~ span.title {
        position: absolute;
        display: block;
        z-index: 1;
        top: 0px;
        font-size: 12px;
        background: #fff;
        border-top: 0px;
        box-shadow: none;
        color: inherit;
        width: 100%;
      }
      &:disabled {
        & ~ span.title {
          background: #f9f9f9 !important;
          color: #aaa;
          &:hover {
            color: #aaa;
            background: none;
            cursor: no-drop;
          }
        }
      }
    }
  }
}

.options {
  max-height: 150px;
  overflow-y: auto;
  // z-index: 999;
}

.bottom-border {
  border-top-right-radius: 0px !important;
  border-top-left-radius: 0px !important;
  border-bottom-right-radius: $radius;
  border-bottom-left-radius: $radius;
  background-color: #f0f0f0;
  display: none;
  padding: 0.8em 2em;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #f0f0f0;
}

.title {
  font-size: 12px !important;
}

.boder-radius {
  border-top-left-radius: $radius;
  border-top-right-radius: $radius;
}

img {
  position: absolute;
  left: 25px;
  top: 15px;
}

.option img,
.option .icon {
  display: none;
}

.sup-title {
  font-size: 10px;
  font-weight: 600;
  position: absolute;
  top: 5px;
  left: 60px;
}

.option .sup-title {
  display: none;
}

.text-option {
  font-weight: 600;
  padding-left: 36px;
  padding-top: 3px;
}

.drop-select-container {
  position: absolute;
  width: calc(100% - 25px);
}
.drop-select-container-parent {
  //width: 300px;
  height: 50px;
}

// adapt dropdown to buttons

.select .title,
.select .placeholder {
  padding: 0.85em 1.6em;
}

.select > i {
  top: 1.4em;
}

img {
  top: auto;
}

.text-option {
  padding-left: 41px;
  padding-top: 7px;
}

.time-button {
  position: absolute;
  background: transparent;
  width: 100%;
  height: 44px;
  outline: none;
  color: transparent;
}
</style>
